import {
  type DataTestId,
  type DOMProps,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';
import { Paragraph, Text } from '@dynatrace/strato-components/typography';

//#region Typings
/**
 * @public
 */
export interface TerminologyDescriptionProps
  extends DOMProps,
    WithChildren,
    StylingProps,
    DataTestId {}
//#endregion Typings

/**
 * Adds the description for the terminology to help the user.
 * @public
 */
export const Description = (props: TerminologyDescriptionProps) => {
  const {
    children,
    id,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  if (typeof children === 'string') {
    return (
      <Paragraph
        id={id}
        data-testid={dataTestId}
        className={consumerClassName}
        style={consumerStyle}
      >
        {children}
      </Paragraph>
    );
  }
  return (
    <Text as="div" textStyle="base" id={id}>
      {children}
    </Text>
  );
};

Description.displayName = 'TerminologyOverlay.Description';
